import { State } from "./state";
import { GetterTree } from "vuex";

import { getError, getIsLoading, getDataItem, getSuccess, getDataList, getTotal, getId } from "@/store/Crud/functions/getters";

function getFilteredStudentCategories(state: State): any {
  return state.filteredStudentCategories;
}

export default <GetterTree<State, any>>{
  getIsLoading,
  getSuccess,
  getError,
  getTotal,
  getId,
  getDataItem,
  getDataList,
  getFilteredStudentCategories,
};
